export default __webpack_public_path__ + "static/media/icon-table-view-selected.e23d57ca.svg";